
class PangoCollCard {
  constructor(element) {
    this.element = element;    
    this.variantIdInput = this.element.querySelector('[pango-variant-id-input]');
    this.init();
  }  
  init() {
    this.attachInputListeners();
  }
  attachInputListeners() {
    const inputs = this.element.querySelectorAll('input[type="radio"]');
    inputs.forEach(input => {
      input.addEventListener('change', (ev) => {
        let selectedVarId = input.value
        this.updateFormElements(selectedVarId) 
      });
    });
  }

  updateFormElements(selectedVarId) { 
    this.variants = JSON.parse(this.element.dataset.variants || '[]');
    const selectedVariant = this.variants.find(variant =>  variant.id == selectedVarId );
    // console.log("Selected variant:", selectedVariant );
    if (selectedVariant) {  
      // LINK
      const linkElement = this.element.querySelector('a');
      const url = new URL(linkElement.href);
      url.searchParams.set('variant', selectedVariant.id);
      linkElement.href = url.toString();
      // IMAGE
      const imageElement = this.element.querySelector('img');
      let selectedVariantImage = selectedVariant.featured_image.src;
      if(selectedVariantImage){
        imageElement.src= selectedVariantImage;
        imageElement.srcset= selectedVariantImage;
      }
      //TITLE
      const titleElement = this.element.querySelector('[data-pango-selected-variant-title]');
      titleElement.textContent=selectedVariant.title;  
      //PRICE
      const finalPrice = this.element.querySelector('[final-price]');
      const moneda = finalPrice.getAttribute('data-moneda')
      const comparePrice = this.element.querySelector('[compare-price]');
      finalPrice.textContent = this.formatCurrency(selectedVariant.price,moneda);
      if(selectedVariant.compare_at_price){
        comparePrice.textContent = this.formatCurrency(selectedVariant.compare_at_price,moneda);
        comparePrice.style.opacity="1";
        finalPrice.classList.add("p-sale");
      } else {
        comparePrice.style.opacity="0";
        finalPrice.classList.remove("p-sale");
      }
      // INPUT VARIANT ID
      this.variantIdInput.value = selectedVariant.id;
      
      const submitButton = this.element.querySelector('button[type="submit"]');
      const available_text = submitButton.dataset.availableText;
      const not_available_text = submitButton.dataset.notAvailableText;
      if (selectedVariant.available) {
        submitButton.disabled = false;
        submitButton.classList.remove('is-disabled');
        submitButton.innerText= available_text;
      } else {
        submitButton.disabled = true;
        submitButton.classList.add('is-disabled');
        submitButton.innerText= not_available_text;
      }
    } else {
      this.variantIdInput.value = '';
      submitButton.disabled = true;
      submitButton.classList.add('is-disabled');
    }
  }
  static initAll() {
    const elements = document.querySelectorAll('[pango-collection-card-class]');
    elements.forEach(el => new PangoCollCard(el));
  }
 
  formatCurrency(number,moneda){
    const adjustedNumber = number / 100; 
    const [integer, decimal] = adjustedNumber.toFixed(2).split('.'); 
    return decimal === '00' ? ` ${moneda}${integer}` : ` ${moneda}${integer},${decimal}`;
  };
}
document.addEventListener('DOMContentLoaded', () => {
  PangoCollCard.initAll();
});
